<template>
  <div>
    <masked-input
      type="text"
      class="el-input__inner"
      v-model="inputVal"
      :mask="dateMask"
      :guide="false"
      :required="!!required"
      :disabled="!!disabled"
      :placeholder="placeholder">
    </masked-input>
  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask';

export default {
  name: 'ElDateInput',
  components: {
    MaskedInput
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: String
  },
  data() {
    return {
      dateMask: [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
      inputVal: this.value || '',
    };
  },
  watch: {
    inputVal(val) {
      this.$emit('input', val);
    },
  },
};
</script>
